import { Grid } from '@mui/material';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Configurations from '../../components/configurations';
import ConfigLayout from '../../layout/dashboard/ConfigLayout';
import { getCurrentUserAssociation } from '../../modules/project';

const ConfigurationPage = () => {
  const location = useLocation();
  const { tab } = queryString.parse(location.search);
  const [selectedTab, setSelectedTab] = useState(tab || 'environments');
  const [user, setUser] = useState({});
  const { projectId } = useParams()

  const fetchUserData = async () => {
    try {
      const response = await getCurrentUserAssociation(projectId);
      setUser(response)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchUserData();
  }, [projectId]);

  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    }
  }, [tab]);
  return (
    <ConfigLayout selectedTab={selectedTab} setSelectedTab={setSelectedTab} user={user}>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <Configurations selectedTab={selectedTab} user={user} />
        </Grid>
      </Grid>
    </ConfigLayout>
  );
};

export default ConfigurationPage;
